import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export const Portal = ({ id, children }) => {
    const portalContainer = document.querySelector(id);
    const containerExist = portalContainer !== null;
    return (
        <React.Fragment>
            { containerExist && (
                ReactDOM.createPortal(
                    children,
                    portalContainer,
                )
            )}
        </React.Fragment>
    );
};

Portal.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};
